import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export type UiNotification = {
  type: 'success' | 'info' | 'error';
  message: string;
};

type UiState = {
  notification: UiNotification | null;
  selectedDate: string; // формат "YYYY-MM-DD"
};

const initialState: UiState = {
  notification: null,
  selectedDate: new Date().toISOString().slice(0, 10), // сегодня
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setNotification(state, action: PayloadAction<UiNotification>) {
      state.notification = action.payload;
    },
    clearNotification(state) {
      state.notification = null;
    },
    setSelectedDate(state, action: PayloadAction<string>) {
      state.selectedDate = action.payload;
    },
    resetUiState() {
      return initialState;
    },
  },
});

export const uiReducer = uiSlice.reducer;
export const uiActions = uiSlice.actions;
